import { styled } from "@material-ui/core";

export const LiveMeterGraphHeaderContainer = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  marginBottom: theme.spacing(2),
}));

export const LiveMeterGraphDropdownContainer = styled("div")({
  width: "30%",
});



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/components/LiveMeterGraph/LiveMeterGraph.styles.js